import vSelect from "vue-select";
import TagModel from "../../../models/TagModel";
import _debounce from 'lodash/debounce';
import TaxonomyModel from "../../../models/TaxonomyModel";

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
		collection: {
			type: Object,
			required: true
		},
		tagModel: {
			type: Object
		},
		emptyMessage: {
			type: String
		}
	},

	components: {
		"v-select": vSelect,
	},

	mounted() {

	},

	data() {
		return {
			taggable: false,
			loading: false
		};
	},

	computed: {
		selectedOptions: {
			cache: false,
			get() {
				return this.$refs.select ? this.$refs.select.selectedValue : [];
			}
		},
		options: {
			get() {
				return this.collection.toArray(true);
			}
		}
	},

	methods: {
		onClose: function () {
			this.context.blurHandler();
		},

		onOptionClick(option) {
			this.context.model.splice(this.context.model.indexOf(option), 1);
		},

		onSearch: _debounce(function (val, loading) {
			if(val.length) {
				loading(true)
				this.taggable = false;
				this.collection.setConfig('params', Object.assign(this.collection.config.params, {query: val}));
				this.collection.fetch().then(() => {
					if(!this.options.filter(o => o.name === val).length) {
						this.taggable = true;
					}
					loading(false);
				})
			} else {
				loading(false)
				let emptyArray = []
				this.$emit('search', {loading, emptyArray})
			}
        }, 500),

		onAddTag(val) {
			this.loading = true;
			const newTaxo = this.tagModel.clone(true).setConfig(this.tagModel.config) || new TagModel();
			newTaxo.set({'name': val.label ? val.label : val});
			newTaxo.post().then(() => {
				//add new model to collection
				this.collection.set(newTaxo);
				//set model as new value so it is selected in the dropdown
				this.context.model.splice(this.context.model.indexOf(val), 1);
				this.context.model.push(this.options.filter(o => o.uuid === newTaxo.uuid)[0]);
				//now we trigger a value refresh (empty/fill)
				const oldval = this.context.model;
				this.context.model = [];
				this.context.model = oldval;

				this.loading = false;
			});
		}
	},
};
